"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SequenceFlow = void 0;
const index_1 = require("../Base/index");
/**
 * Describes a BPMN SequenceFlow element, which is used to connect
 * two FlowNodes together.
 */
class SequenceFlow extends index_1.BaseElement {
}
exports.SequenceFlow = SequenceFlow;
//# sourceMappingURL=SequenceFlow.js.map